import React from 'react'
import { GridColDef } from '@mui/x-data-grid-premium'
import format from 'date-fns/format'
import { InnerLink } from 'src/components/ui'
import { BleConnectionLog } from 'src/api'

export namespace BleConnectionLogColumns {
  export const Id: GridColDef<BleConnectionLog> = {
    field: 'id',
    headerName: 'ID',
    type: 'number',
    minWidth: 100,
    editable: false,
    renderCell: ({ value, row }) => {
      if (!row.id) return '-'
      return <InnerLink to={`/ble-connection-logs/${row.id}`}>{value}</InnerLink>
    },
  }

  export const DeviceType: GridColDef<BleConnectionLog> = {
    field: 'deviceType',
    headerName: 'Device type',
    type: 'string',
    minWidth: 150,
    editable: false,
    valueGetter: ({ row }) => row.deviceType || '-',
  }

  export const Step: GridColDef<BleConnectionLog> = {
    field: 'step',
    headerName: 'Step',
    type: 'string',
    minWidth: 150,
    editable: false,
    valueGetter: ({ row }) => row.step || '-',
  }

  export const Status: GridColDef<BleConnectionLog> = {
    field: 'status',
    headerName: 'Status',
    type: 'string',
    minWidth: 130,
    editable: false,
    valueGetter: ({ row }) => row.status || '-',
  }

  export const EventType: GridColDef<BleConnectionLog> = {
    field: 'eventType',
    headerName: 'Event type',
    type: 'string',
    minWidth: 180,
    editable: false,
    valueGetter: ({ row }) => row.eventType || '-',
  }

  export const User: GridColDef<BleConnectionLog> = {
    field: 'user.name',
    headerName: 'User',
    type: 'string',
    minWidth: 180,
    editable: false,
    valueGetter: ({ row }) => row.user?.name || null,
    renderCell: ({ value, row }) => {
      if (!value || !row.userId) return '-'
      return <InnerLink to={`/users/${row.userId}`}>{value}</InnerLink>
    },
  }

  export const Contractor: GridColDef<BleConnectionLog> = {
    field: 'contractor.name',
    headerName: 'Contractor',
    type: 'string',
    minWidth: 200,
    editable: false,
    valueGetter: ({ row }) => row.contractor?.name || null,
    renderCell: ({ value, row }) => {
      if (!value || !row.contractorId) return '-'
      return <InnerLink to={`/contractors/${row.contractorId}`}>{value}</InnerLink>
    },
  }

  export const Project: GridColDef<BleConnectionLog> = {
    field: 'project.name',
    headerName: 'Project',
    type: 'string',
    minWidth: 200,
    editable: false,
    valueGetter: ({ row }) => row.project?.name || null,
    renderCell: ({ value, row }) => {
      if (!value || !row.projectId) return '-'
      return <InnerLink to={`/projects/${row.projectId}`}>{value}</InnerLink>
    },
  }

  export const Section: GridColDef<BleConnectionLog> = {
    field: 'projectSection.name',
    headerName: 'Section',
    type: 'string',
    minWidth: 200,
    editable: false,
    valueGetter: ({ row }) => row.projectSection?.name || null,
    renderCell: ({ value, row }) => {
      if (!value || !row.projectSectionId) return '-'
      return <InnerLink to={`/sections/${row.projectSectionId}`}>{value}</InnerLink>
    },
  }

  export const Probe: GridColDef<BleConnectionLog> = {
    field: 'probeRawId',
    headerName: 'RapidRH probe',
    type: 'string',
    minWidth: 180,
    editable: false,
    valueGetter: ({ row }) => row.probeRawId || null,
    renderCell: ({ value, row }) => {
      if (!value || !row.probeRawId) return '-'
      return <InnerLink to={`/wagner-probes/${row.probeRawId}`}>{value}</InnerLink>
    },
  }

  export const EventName: GridColDef<BleConnectionLog> = {
    field: 'event.eventName',
    headerName: 'Event name',
    type: 'string',
    minWidth: 200,
    editable: false,
    valueGetter: ({ row }) => row.event?.eventCardRenderingData?.eventName || row.event?.eventCardRenderingData?.eventDetails || null,
    renderCell: ({ value, row }) => {
      if (!value || !row.eventId) return '-'
      return <InnerLink to={`/events/${row.eventId}`}>{value}</InnerLink>
    },
  }

  export const AppVersion: GridColDef<BleConnectionLog> = {
    field: 'appVersion',
    headerName: 'App version',
    type: 'string',
    minWidth: 150,
    editable: false,
    valueGetter: ({ row }) => row.appVersion || '-',
  }

  export const DeviceOS: GridColDef<BleConnectionLog> = {
    field: 'deviceOS',
    headerName: 'Device OS',
    type: 'string',
    minWidth: 150,
    editable: false,
    valueGetter: ({ row }) => row.deviceOS || '-',
  }

  export const OccurredAt: GridColDef<BleConnectionLog> = {
    field: 'occurredAt',
    headerName: 'Occurred At',
    type: 'string',
    minWidth: 200,
    editable: false,
    valueFormatter: ({ value }) => (value ? format(new Date(value), 'PPpp') : '-'),
  }
}
